if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.cart = document.querySelector('cart-drawer');

        if (!this.form || !this.submitButton) return;

        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        if (this.cart) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.form || !this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        this.cart = document.querySelector('cart-drawer');
        const formData = new FormData(this.form);
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement?.(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            const rebuyActive =
              typeof window.isRebuySmartCartActive === 'function' && window.isRebuySmartCartActive();

            if (rebuyActive) {
              document.dispatchEvent(new CustomEvent('rebuy:cart.open', { bubbles: true }));
              return;
            }

            this.cart = document.querySelector('cart-drawer');
            const cartType = window.miraCartType || (window.settings && window.settings.cart_type);
            if (!this.cart || cartType !== 'drawer') {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = window.CartPerformance?.createStartingMarker?.('add:wait-for-subscribers');
            if (!this.error) {
              const published = publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
              if (startMarker && published?.then) {
                published.then(() => {
                  window.CartPerformance?.measureFromMarker?.('add:wait-for-subscribers', startMarker);
                });
              }
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => this.renderCartContents(response));
                },
                { once: true }
              );
              quickAddModal.hide(true);
              return;
            }
            this.renderCartContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            window.CartPerformance?.measureFromEvent?.('add:user-action', evt);
          });
      }

      renderCartContents(response) {
        this.cart = document.querySelector('cart-drawer');
        if (this.cart && typeof this.cart.renderContents === 'function') {
          this.cart.renderContents(response);
          return;
        }

        if (typeof window.loadCartDrawerAssets === 'function') {
          window.loadCartDrawerAssets().then(() => {
            this.cart = document.querySelector('cart-drawer');
            this.cart?.renderContents?.(response);
          });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
